<app-hotel-price-filter></app-hotel-price-filter>
<div class="septor"></div> 
<app-hotel-namesearch-filter></app-hotel-namesearch-filter>
<div class="septor"></div>
<app-near-by-filter></app-near-by-filter>
<div class="septor"></div>
<app-free-cancel-filter></app-free-cancel-filter>
<div class="septor"></div>
<app-hotel-accomodation-filter></app-hotel-accomodation-filter>
<div class="septor"></div>
<app-rating-filter></app-rating-filter>
<div class="septor"></div> 
<app-amenities-filter></app-amenities-filter>
<div class="septor"></div> 
<app-interest-filter></app-interest-filter>
<div class="septor"></div> 
<!-- <app-meal-plan-filter></app-meal-plan-filter> -->

 